module.exports = __webpack_public_path__ + "static/img/partner5.0509288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/partner5.png
// module id = ETxn
// module chunks = 0